const PERFORMANCE_METRIC_DATA_URL = `/measurement/metric-data`;

export const performanceMetricDataApiFactory = ({ callPostApi }) => ({
    updatePerformanceMetricData: data => callPostApi(PERFORMANCE_METRIC_DATA_URL, data, {}, true),
});
